import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { blankResponseArray } from '../constants'
import State from './types'
import { RootState } from '../types'
import { blankCustomer, blankSearchFilters } from './constants'
import _ from 'lodash'

export const state: State = {
  activeCustomer: _.assign({}, _.cloneDeep(blankCustomer)),
  customers: _.assign({}, _.cloneDeep(blankResponseArray)),
  shipTos: _.assign({}, _.cloneDeep(blankResponseArray)),
  error: '',
  loading: true,
  searchFilters: _.cloneDeep(blankSearchFilters),
  customerContacts: [],
}

const namespaced = true

export const customer: Module<State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
